module.exports = function (name) {
  $('#nav-icon4').click(function(){
		$(this).toggleClass('navicon--open');
    $(".navbar__links--responsive").toggleClass('open');
	});
  $('.navbar--smalllink').click(function(){
		$('#nav-icon4').toggleClass('navicon--open');
    $(".navbar__links--responsive").toggleClass('open');
	});
  return true
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/js/navbar.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9